var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Play"),React.createElement("path",{"d":"M0 15.884V1.83167C0 1.0405 0.875245 0.562657 1.54076 0.990486L13.1132 8.42994C13.7447 8.83587 13.7204 9.76692 13.0686 10.1394L1.49614 16.7522C0.829482 17.1332 0 16.6518 0 15.884Z","key":1})]);
}

PlayInline.defaultProps = {"width":"14","height":"17","viewBox":"0 0 14 17","fill":"none","className":"icon"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
